export const formatVilleToLabelValue = (ville) =>
  ville && {
    label: ville.name,
    value: ville.id,
  };

export const formatAnalyseToLabelValue = (analyse) =>
  analyse && {
    label: analyse.designation,
    value: analyse.id,
    prix: analyse.price,
    type: analyse.type,
  };

export const formatAnalyseToObject = (analyse) =>
  analyse && {
    designation: analyse.label,
    price: analyse.prix,
    type: analyse.type,
    id: analyse.value,
  };

export const formatSpecailiteToLabelValue = (speciality) =>
  speciality && {
    label: speciality.designation,
    value: speciality.id,
  };

export const formatSecteurToLabelValue = (Secteur) =>
  Secteur && {
    label: Secteur.name,
    value: Secteur.id,
  };
